import { Link } from "react-router-dom";

const heroStats = [
  { num: "1.7 亿", label: "科技文献" },
  { num: "90PB", label: "科学数据" },
  { num: "500+", label: "科研工具" },
  { num: "7 大", label: "学科领域" },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-6 pt-24 pb-20 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0d1428] via-[#080808] to-[#080808]"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-[#3d69e8]/10 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#3d69e8] animate-pulse flex-shrink-0"></span>
          <span className="text-xs text-white/60 whitespace-nowrap">你的下一个重大发现，从这里开始</span>
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] tracking-tight mb-6">
          加速你的下一个<br />
          <span className="text-[#3d69e8]">重大发现</span>
        </h1>

        {/* Sub */}
        <p className="text-base md:text-lg text-white/50 mb-8 leading-relaxed max-w-xl mx-auto">
          从想法到突破，AI 陪你走完最后一公里。<br />
          覆盖 1.7 亿科技文献、90PB 科学数据、500+ 科研工具。
        </p>

        {/* Inline hero stats */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mb-10">
          {heroStats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{s.num}</div>
              <div className="text-xs text-white/40 mt-0.5">{s.label}</div>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#3d69e8] hover:bg-[#3060d0] text-white text-sm font-medium px-6 py-3 rounded-lg transition-colors cursor-pointer no-underline whitespace-nowrap"
          >
            <i className="ri-play-circle-line"></i>
            立即开始你的研究
          </Link>
          <a
            href="#workflow-section"
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white text-sm font-medium px-6 py-3 rounded-lg transition-colors cursor-pointer no-underline whitespace-nowrap"
          >
            观看平台演示
          </a>
        </div>
      </div>
    </section>
  );
}
